module.exports = __webpack_public_path__ + "sx14-ee0105db.png";